import { cn } from '@/lib';

export interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    label?: string;
}

export const Loader = ({ label, className, ...rest }: LoaderProps) => {
    return (
        <div
            className={cn(
                'text-md bg-neutral-disabled flex h-full w-full flex-col items-center justify-center gap-4 font-bold text-[var(--text-color-primary-fg-brand-intense)]',
                className
            )}
            {...rest}
        >
            <span className='text-brand-main animate-in fade-in slide-in-from-bottom-[20px] fill-mode-backwards duration-600'>
                <svg
                    width='32'
                    height='32'
                    viewBox='0 0 32 32'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                    className='animate-spin'
                >
                    <path
                        d='M14.5455 30.5455V24.7273C14.5455 23.9239 15.1967 23.2727 16 23.2727C16.8033 23.2727 17.4545 23.9239 17.4545 24.7273V30.5455C17.4545 31.3488 16.8033 32 16 32C15.1967 32 14.5455 31.3488 14.5455 30.5455ZM8.78896 21.1526C9.357 20.5846 10.2794 20.5846 10.8474 21.1526C11.4154 21.7206 11.4154 22.643 10.8474 23.211L6.73214 27.3247C6.16408 27.8923 5.24324 27.8926 4.67532 27.3247C4.10741 26.7568 4.10766 25.8359 4.67532 25.2679L8.78896 21.1526ZM21.1526 21.1526C21.7206 20.5846 22.643 20.5846 23.211 21.1526L27.3247 25.2679C27.8923 25.8359 27.8926 26.7568 27.3247 27.3247C26.7568 27.8926 25.8359 27.8923 25.2679 27.3247L21.1526 23.211C20.5846 22.643 20.5846 21.7206 21.1526 21.1526ZM7.27273 14.5455C8.07605 14.5455 8.72727 15.1967 8.72727 16C8.72727 16.8033 8.07605 17.4545 7.27273 17.4545H1.45455C0.651222 17.4545 0 16.8033 0 16C0 15.1967 0.651222 14.5455 1.45455 14.5455H7.27273ZM30.5455 14.5455C31.3488 14.5455 32 15.1967 32 16C32 16.8033 31.3488 17.4545 30.5455 17.4545H24.7273C23.9239 17.4545 23.2727 16.8033 23.2727 16C23.2727 15.1967 23.9239 14.5455 24.7273 14.5455H30.5455ZM4.67532 4.78896C5.24319 4.22129 6.16412 4.22153 6.73214 4.78896L10.8474 8.90422C11.4147 9.47225 11.415 10.3932 10.8474 10.961C10.2794 11.5291 9.357 11.5291 8.78896 10.961L4.67532 6.8474C4.10729 6.27937 4.10729 5.357 4.67532 4.78896ZM25.2679 4.78896C25.8359 4.22153 26.7568 4.22129 27.3247 4.78896C27.8927 5.357 27.8927 6.27937 27.3247 6.8474L23.211 10.961C22.643 11.5291 21.7206 11.5291 21.1526 10.961C20.585 10.3932 20.5853 9.47225 21.1526 8.90422L25.2679 4.78896ZM14.5455 7.27273V1.45455C14.5455 0.651222 15.1967 0 16 0C16.8033 0 17.4545 0.651222 17.4545 1.45455V7.27273C17.4545 8.07605 16.8033 8.72727 16 8.72727C15.1967 8.72727 14.5455 8.07605 14.5455 7.27273Z'
                        fill='currentColor'
                    />
                </svg>
            </span>
            {label && (
                <span className='animate-in fade-in slide-in-from-bottom-[50px] fill-mode-backwards delay-100 duration-600'>
                    {label}
                </span>
            )}
        </div>
    );
};
